import { render, staticRenderFns } from "./TranshipmentManagementTab.vue?vue&type=template&id=5bc2b90c"
import script from "./TranshipmentManagementTab.vue?vue&type=script&lang=js"
export * from "./TranshipmentManagementTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports